const logout = (entraClient, redirectUri) => entraClient.logoutPopup({
	account: entraClient.getActiveAccount(),
	postLogoutRedirectUri: redirectUri,
});

export default logout;



// WEBPACK FOOTER //
// ./src/js/logout.js